// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3D2Zh","text":"SelectPayment_text__2MOfg","title":"SelectPayment_title__P7UFc","btn":"SelectPayment_btn__18dHo"};